const initialClientDataState = {
  data : false,
  columns: false,
  allAddresses: false,
  client_updates_in_progress : {}
}

export const ClientDataReducer = (state = initialClientDataState, action = {}) => {

    switch (action.type) {
        case 'CLIENTDATA':
            return {
              ...state,
              data: action.fetchedClientData.data.data,
              columns: action.fetchedClientData.data.columns,
              allAddresses: action.fetchedClientData.data.allAddresses
            }
        case 'CLEAR_PROGRESS_ITEMS':
            return {
                ...state,
                client_updates_in_progress : {}
            }
        case 'CLIENT_UPDATE_IN_PROGRESS':

            return {
                ...state,
                client_updates_in_progress : {
                    ...state.client_updates_in_progress,
                    [action.payload.unique] : {
                        client_id : action.payload.client_id,
                        progress: action.payload.progress,
                        message: action.payload.message
                    }
                }
            }
        case 'USER_LOGOUT':
          return initialClientDataState;

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/ClientDataReducer.js